module.exports = __webpack_public_path__ + "img/appstore.b67e11ec.png";